import { datadogLogs } from '@datadog/browser-logs'
import { isDatadogLogNoise } from '@/services/datadog-log-filter.service'
import { scrubDatadogLog } from '@/services/datadog-log-scrubber.service'

export const activateDatadog = () => {
  const modeToEnvMap: { [key: string]: string } = {
    local: 'local',
    development: 'dev',
    staging: 'non-prod',
    production: 'prod',
  }

  const token: string = import.meta.env.VITE_DD_TOKEN as string
  const mode: string = import.meta.env.VITE_MODE as string
  const env: string | null = modeToEnvMap[mode] ?? null

  if (env === null) {
    console.error('Datadog environment not found.')
    return
  }

  datadogLogs.init({
    clientToken: token,
    site: 'datadoghq.eu',
    service: 'applicantportal',
    env: env,
    version: `${import.meta.env.VITE_APP_VERSION}`,
    forwardConsoleLogs: ['debug', 'warn'],
    forwardErrorsToLogs: true,
    beforeSend: (log) => {
      scrubDatadogLog(log)
      return !isDatadogLogNoise(log)
    },
  })
}

export default activateDatadog
